import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { toggledInSet } from '../core/iching-set.util';
import { IChingFootnote } from '../core/iching.models';

/** Alinea's met optionele voetnoot-badges (voetnoot hangt aan een JSON-pad). */
@Component({
  selector: 'hd-iching-prose',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host { display: block; }
    p { margin: 0 0 0.6em; }
    p.is-verse { margin: 0; }
    .footnote { font-size: 0.75em; vertical-align: super; color: var(--primary); margin-left: 2px; cursor: help; background: none; border: 0; padding: 0; }
    .footnote-body { margin: 0.3em 0 0.8em 1em; padding-left: 0.6em; border-left: 2px solid var(--primary-25, var(--primary)); font-size: 0.9em; color: var(--text-secondary, inherit); }
  `,
  template: `
    @for (par of items(); track $index) {
      <p [class]="paragraphClass()">{{ par.text }}
        @for (note of par.notes; track note.number) {
          <button type="button" class="footnote" (click)="toggle(note.number)" [attr.aria-expanded]="open().has(note.number)">{{ note.number }}</button>
        }
      </p>
      @for (note of par.notes; track note.number) {
        @if (open().has(note.number)) {
          <div class="footnote-body">
            @for (np of note.paragraphs; track $index) {
              <p>{{ np }}</p>
            }
          </div>
        }
      }
    }
  `,
})
export class HdIChingProseComponent {
  readonly paragraphs = input.required<readonly string[]>();
  /** JSON-pad van deze alinea-lijst, bv. 'text.lines[1].commentary'; voetnoten met `at` = `${path}[i]` hangen aan alinea i. */
  readonly path = input<string>('');
  readonly footnotes = input<readonly IChingFootnote[]>([]);
  readonly paragraphClass = input<string>('');

  protected readonly open = signal(new Set<number>());
  protected readonly items = computed(() =>
    this.paragraphs().map((text, i) => ({
      text,
      notes: this.footnotes().filter(n => n.at === `${this.path()}[${i}]`),
    })),
  );

  protected toggle(number: number): void {
    this.open.update(set => toggledInSet(set, number));
  }
}
